<script setup lang="ts">
import SearchDataTable from "@/components/tables/SearchDataTable.vue";
import stores from "@/data/stores.gen";
import { FormEmbeddedTable, FormValues } from "../types";
const props = defineProps<{
  config: FormEmbeddedTable;
  value: FormValues;
  loading?: boolean;
}>();

////////////////////////////////////////////////////////////
//////////////////// SETUP /////////////////////////////////
////////////////////////////////////////////////////////////
const store = stores[props.config.entityName]();

////////////////////////////////////////////////////////////
//////////////////// METHODS ///////////////////////////////
////////////////////////////////////////////////////////////
const filters = computed(() =>
  props.config.filters.map((filter) => {
    // If the value is a function, call it with the current FormValue's
    if (typeof filter.value === "function") {
      return {
        ...filter,
        value: filter.value(props.value),
      };
    }

    return {
      ...filter,
      value: filter.value,
    };
  }),
);
</script>

<template>
  <VRow>
    <VCol cols="12">
      <h4>{{ config.title }}</h4>
    </VCol>

    <VCol>
      <SearchDataTable
        :entity-name="config.entityName"
        :store="store"
        :to-table-row="config.toTableRow"
        :columns="config.columns"
        :filters-config="filters"
        :default-actions="config.defaultActions"
        :multi-items-actions="config.multiItemsActions"
        :hide-filter-bar="true"
      />
    </VCol>
  </VRow>
</template>
